import type { FC } from 'react';
import dayjs from 'dayjs';
import type { Frequency } from '../../../types/calendar';

export interface CalendarIntervalProps {
    frequency: Frequency;
    periodStartDate: string;
    cellWidth: number;
    pxPerDay: number;
}

const CalendarInterval: FC<CalendarIntervalProps> = ({ frequency, periodStartDate, cellWidth, pxPerDay }) => {
    if (frequency === 'W') {
        const sectionWidth = cellWidth / 7;
        return (
            <div className="pointer-events-none absolute inset-0 z-0">
                {Array.from({ length: 6 }, (_, i) => (
                    <div
                        key={i}
                        className="absolute top-0 bottom-0 border-r border-dotted border-[#D4D4D8]"
                        style={{ left: (i + 1) * sectionWidth }}
                    />
                ))}
            </div>
        );
    }

    if (frequency === 'Q') {
        const qStart = dayjs(periodStartDate);
        const m1Days = qStart.add(1, 'month').diff(qStart, 'day');
        const m2Days = qStart.add(2, 'month').diff(qStart, 'day');
        return (
            <div className="pointer-events-none absolute inset-0 z-0">
                <div
                    className="absolute top-0 bottom-0 border-r border-dashed border-[#D4D4D8]"
                    style={{ left: m1Days * pxPerDay }}
                />
                <div
                    className="absolute top-0 bottom-0 border-r border-dashed border-[#D4D4D8]"
                    style={{ left: m2Days * pxPerDay }}
                />
            </div>
        );
    }

    const mStart = dayjs(periodStartDate);
    const totalDays = mStart.add(1, 'month').diff(mStart, 'day');
    const dividerCount = Math.floor(totalDays / 7);
    return (
        <div className="pointer-events-none absolute inset-0 z-0">
            {Array.from({ length: dividerCount }, (_, i) => (
                <div
                    key={i}
                    className="absolute top-0 bottom-0 border-r border-dashed border-[#D4D4D8]"
                    style={{ left: (i + 1) * 7 * pxPerDay }}
                />
            ))}
        </div>
    );
};

CalendarInterval.displayName = 'CalendarInterval';
export default CalendarInterval;
